import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteStore } from "../redux/storesSagas";

export const Delete = ({ isOpen, onClose, selected: { store: { id, name } } = {} }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(deleteStore({ id }));
    onClose();
  };

  return (
    <MainModal
      parentSelector=".stores"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={300}
      height="auto"
      primaryButtonText="Delete"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      Are you sure to delete <span className="text-bold">{name}</span>?
    </MainModal>
  );
};
